// extracted by mini-css-extract-plugin
export var bold = "_ys-0";